var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 25L80 25L80 75L20 75Z",
    fill: "#a485cc",
    stroke: "#000",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 50 25 L 80 25 L 80 75 L 50 75",
    fill: "#a485cc",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0s",
    keyTimes: "0;0.5;0.501;1",
    values: "M50 25L80 25L80 75L50 75;M50 25L50 20L50 80L50 75;M50 25L80 25L80 75L50 75;M50 25L80 25L80 75L50 75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0s",
    keyTimes: "0;0.5;0.5001;1",
    values: "1;1;0;0"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 50 25 L 72.1653 23.6942 L 72.1653 76.3058 L 50 75",
    fill: "#a485cc",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.166s",
    keyTimes: "0;0.5;0.501;1",
    values: "M50 25L80 25L80 75L50 75;M50 25L50 20L50 80L50 75;M50 25L80 25L80 75L50 75;M50 25L80 25L80 75L50 75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.166s",
    keyTimes: "0;0.5;0.5001;1",
    values: "1;1;0;0"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 50 25 L 62.3253 22.0542 L 62.3253 77.9458 L 50 75",
    fill: "#a485cc",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.33s",
    keyTimes: "0;0.5;0.501;1",
    values: "M50 25L80 25L80 75L50 75;M50 25L50 20L50 80L50 75;M50 25L80 25L80 75L50 75;M50 25L80 25L80 75L50 75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.33s",
    keyTimes: "0;0.5;0.5001;1",
    values: "1;1;0;0"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 50 25 L 20 25 L 20 75 L 50 75",
    fill: "#a485cc",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.33s",
    keyTimes: "0;0.499;0.5;1",
    values: "M50 25L20 25L20 75L50 75;M50 25L20 25L20 75L50 75;M50 25L50 20L50 80L50 75;M50 25L20 25L20 75L50 75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.33s",
    keyTimes: "0;0.4999;0.5;1",
    values: "0;0;1;1"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 50 25 L 20 25 L 20 75 L 50 75",
    fill: "#a485cc",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.166s",
    keyTimes: "0;0.499;0.5;1",
    values: "M50 25L20 25L20 75L50 75;M50 25L20 25L20 75L50 75;M50 25L50 20L50 80L50 75;M50 25L20 25L20 75L50 75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.166s",
    keyTimes: "0;0.4999;0.5;1",
    values: "0;0;1;1"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 50 25 L 22.1253 24.6458 L 22.1253 75.3542 L 50 75",
    fill: "#a485cc",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0s",
    keyTimes: "0;0.499;0.5;1",
    values: "M50 25L20 25L20 75L50 75;M50 25L20 25L20 75L50 75;M50 25L50 20L50 80L50 75;M50 25L20 25L20 75L50 75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0s",
    keyTimes: "0;0.4999;0.5;1",
    values: "0;0;1;1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.a49e3baf177b371c94216f8c19bf5841.svg";
export { ForwardRef as ReactComponent };